module.exports = __webpack_public_path__ + "img/image1.763bddd8.png";